(function () {
  function activateTab(root, tab) {
    var tabs = root.querySelectorAll('[data-qet-tab]');
    tabs.forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }

  function setCard(card, open) {
    card.classList.toggle('is-open', open);
    var btn = card.querySelector('[data-qet-toggle]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init(root) {
    if (root.dataset.qetReady) return;
    root.dataset.qetReady = 'true';
    var singleOpen = root.dataset.singleOpen === 'true';

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-qet-tab]');
      if (tab && root.contains(tab)) {
        activateTab(root, tab);
        return;
      }
      var toggle = e.target.closest('[data-qet-toggle]');
      if (toggle && root.contains(toggle)) {
        // Links inside the expanded bullets stay clickable; only the bar toggles.
        var card = toggle.closest('[data-qet-card]');
        var willOpen = !card.classList.contains('is-open');
        if (willOpen && singleOpen) {
          var panel = card.closest('[data-qet-panel]');
          panel.querySelectorAll('[data-qet-card].is-open').forEach(function (other) {
            if (other !== card) setCard(other, false);
          });
        }
        setCard(card, willOpen);
      }
    });

    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-qet-tab]');
      if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-qet-tab]'));
      var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
      var next = tabs[(i + tabs.length) % tabs.length];
      activateTab(root, next);
      next.focus();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-qet]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init on reload, and show the tab that holds the selected block.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-qet]');
    if (!root) return;
    var panel = e.target.matches('[data-qet-panel]') ? e.target : e.target.closest('[data-qet-panel]');
    if (!panel) return;
    var tab = root.querySelector('[aria-controls="' + panel.id + '"]');
    if (tab) activateTab(root, tab);
    if (e.target.matches('[data-qet-card]')) setCard(e.target, true);
  });
})();
